import { getApi } from './init';
import mitt from 'mitt';
import wx from 'weixin-js-sdk';
import { getWxAuthManager } from './wx-auth-manager';

class WxSDKManager {
  _wx;
  _initing = false;
  _eventBus = mitt();

  _emit(type: string, data: any) {
    this._eventBus.emit(type, data);
  }

  _on(type: string, handler: any) {
    this._eventBus.on(type, handler);
  }

  _once(type: string, handler: (data: any) => void) {
    const fn = (args: any) => {
      this._eventBus.off(type, fn);
      handler(args);
    };
    this._eventBus.on(type, fn);
  }

  async getWx() {
    const wxAuthManager = getWxAuthManager();
    if (!wxAuthManager.isWxBrowser()) {
      console.warn('需要再微信浏览器执行');
      return;
    }

    if (this._wx) return this._wx;

    return new Promise(async (resolve) => {
      this._once('init', async (wx) => {
        this._wx = wx;
        resolve(wx);
      });

      if (!this._initing) {
        this._initing = true;

        const { tcWechatApi } = getApi();
        const { nonceStr, signature, timestamp, appId } = await tcWechatApi.getWechatSdkInitParams({
          url: location.href,
        });
        wx.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名
          jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          this._emit('init', wx);
          this._initing = false;
        });
      }
    });
  }
}

let wxSDKManager;
export function getWxSDKManager() {
  if (!wxSDKManager) {
    wxSDKManager = new WxSDKManager();
  }
  return wxSDKManager;
}
